import { Trans } from "@lingui/macro";
import type { PrivateImgProps } from "@winamp/media-upload/BytescaleContext/PrivateImg.js";
import { GridCardCover } from "@winamp/ui/components/GridCard/GridCardCover.js";
import { classNames } from "@winamp/ui/utils/classNames.js";
import { Link, type LinkProps } from "react-router";

export function ServiceDetailsCard({
  className,
  ...props
}: React.ComponentPropsWithoutRef<"div">) {
  return (
    <div
      className={classNames(
        "flex flex-col gap-4 border border-primary rounded-xl p-6 pb-8 w-full h-fit",
        className,
      )}
      {...props}
    />
  );
}

export function ServiceDetailsCardCover({
  className,
  src = "",
  children,
  ...props
}: PrivateImgProps) {
  return (
    <div className="flex flex-col gap-2 relative group">
      <GridCardCover type="audio" src={src} {...props}>
        <div className="absolute bottom-0 right-0 z-20 m-4 group-hover:opacity-100 opacity-100 md:opacity-0 transition-opacity">
          {children}
        </div>
      </GridCardCover>

      {!src && (
        <ServiceDetailsCardError>
          <Trans>Cover image is required.</Trans>
        </ServiceDetailsCardError>
      )}
    </div>
  );
}

export function ServiceDetailsCardTitleWrapper({
  children,
}: { children: React.ReactNode }) {
  return (
    <div className="group gap-2 grid grid-cols-[1fr_1.5rem] gap-x-3 gap-y-1 w-full">
      {children}
    </div>
  );
}

export function ServiceDetailsCardTitle({
  className,
  ...props
}: React.ComponentPropsWithoutRef<"h3"> | LinkProps) {
  return "to" in props ? (
    <Link
      className={classNames(
        "font-semibold text-primary text-xl hover:underline break-words min-w-0",
        className,
      )}
      {...props}
    />
  ) : (
    <h3
      className={classNames("font-semibold text-primary text-xl", className)}
      {...props}
    />
  );
}

export function ServiceDetailsCardDescription({
  className,
  ...props
}: React.ComponentPropsWithoutRef<"span">) {
  return (
    <span
      className={classNames(
        "text-secondary text-sm font-normal break-words",
        className,
      )}
      {...props}
    />
  );
}

export function ServiceDetailsCardError({
  className,
  ...props
}: React.ComponentPropsWithoutRef<"span">) {
  return (
    <span
      className={classNames("text-error text-sm/5 font-normal", className)}
      {...props}
    />
  );
}
